module.exports = __webpack_public_path__ + "static/z_tall_uvu-1fd773ceff3b1c4485419aba703842bd.jpg";